import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import { t } from '../../../../../modules/infra/i18n';
import Form from './DiscountForm';
import SimpleHeader from '../../../headers/simpleHeader';
import * as actions from '../actions';
import * as shapes from '../shapes';
import { trimFunction } from '../../../../common/trimData';
import discountTypes from '../discountTypes';
import discountAssignment from '../discountAssignment';

const emptyState = {
  type: discountTypes.percentage,
  assignment: discountAssignment.all,
  value: 0,
};

const Add = ({ onSubmit, baseUrl }) => (
  <div>
    <SimpleHeader heading={t('settings:discounts.add_discount_title')} />
    <Form initialValues={emptyState} onSubmit={trimFunction(onSubmit)} baseUrl={baseUrl} />
  </div>
);
Add.propTypes = {
  onSubmit: shapes.handler.isRequired,
  baseUrl: shapes.url.isRequired,
};

const mapStateToProps = (state) => ({
  shop: state.auth.shop,
  barberUser: state.auth.barberUser,
  baseUrl: state.auth.barberUser ? '/barber/settings/discounts' : '/settings/discounts',
});
const mapDispatchToProps = {
  addShopDiscount: actions.addShopDiscount,
  addBarberDiscount: actions.addBarberDiscount,
};

const addHandlers = withHandlers({
  onSubmit: (props) => (data) => {
    if (props.barberUser) {
      return props.addBarberDiscount(props.barberUser.id, data);
    }

    return props.addShopDiscount(props.shop, data);
  },
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps), addHandlers)(Add);
